(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("@uirouter/visualizer", [], factory);
	else if(typeof exports === 'object')
		exports["@uirouter/visualizer"] = factory();
	else
		root["@uirouter/visualizer"] = factory();
})(window, function() {
return 